import mapboxgl from 'mapbox-gl'

window.mapJs = {};

(function (mapJsApp) {

    mapJsApp.InitializeMap = function () {

        if ($("#map-container").length) {
            let mapDiv = $("#map-container");
            mapboxgl.accessToken = mapDiv.data("accesstoken");
            let latitude = mapDiv.data("latitude");
            let longitude = mapDiv.data("longitude");
            let zoom = mapDiv.data("zoom");

            const map = new mapboxgl.Map({
                container: 'map-container',
                center: [longitude, latitude],
                zoom: zoom,
                cooperativeGestures: true
            });

            map.addControl(new mapboxgl.NavigationControl());

            mapDiv.siblings("#map-markers").find(".marker").each(function () {
                let element = document.createElement('div');
                element.className = 'map-marker';
                element.innerHTML = document.getElementById('marker-icon').innerHTML;
                element.dataset.filter = $(this).data('tags');

                if ($(this).attr('id') != undefined) element.id = $(this).attr('id');

                latitude = $(this).data("latitude");
                longitude = $(this).data("longitude");

                const markerCoordinates = [longitude, latitude];
                let marker = new mapboxgl.Marker(element)
                    .setLngLat(markerCoordinates);

                if ($(this).find(".popup-content").length) {
                    let popup = new mapboxgl.Popup({ anchor: 'center',  maxWidth: 'none', focusAfterOpen: false, closeButton: false })
                        .setHTML($(this).find(".popup-content").html())
                        .setLngLat(map.getCenter());
                    marker.setPopup(popup);

                    marker.getElement().addEventListener('click', () => {
                        map.flyTo({ center: marker.getLngLat(), essential: true });
                    });
                }

                marker.addTo(map);
                $(this).remove();
            });

            $("#map-container").on("click", ".map-tile__close-button", function () {
                $('.mapboxgl-popup').remove();
            });

        }
    }

    $(document).ready(function () {

        mapJsApp.InitializeMap();

    }); // document ready
})(window.mapJs);
